import * as React from 'react';
import {EventAnnotationType} from 'src/js/containers/encounter/components/EventAnnotationType';
import {TimelineAnnotationTypeFormatterValueProps} from 'src/js/model/encounter_timeline';

interface TimelineAnnotationTypeFormatterOwnProps {
  value: TimelineAnnotationTypeFormatterValueProps;
}

type Props = TimelineAnnotationTypeFormatterOwnProps;

export class TimelineAnnotationTypeFormatter extends React.PureComponent<Props> {
  static displayName = 'TimelineAnnotationTypeFormatter';

  render() {
    const {value} = this.props;
    return value ? (
      <div>
        {value &&
          value.annotations &&
          value.annotations.map((annotation, idx) => (
            /* eslint-disable-next-line react/no-array-index-key */
            <EventAnnotationType key={idx} annotation={annotation} />
          ))}
      </div>
    ) : (
      ''
    );
  }
}
